import { ReactNode } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  width: 100%;
  border-bottom: 1px solid #a6a9b0;
  margin-bottom: 24px;
  color: #181818;
  font-size: 12px;
  line-height: 18px;
`

interface IProps {
  children?: ReactNode;
}

export const Title: React.FC<IProps> = ({children}) => {
  return (
    <Wrapper>
      { children }
    </Wrapper>
  )
}
